import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';
import { isLightMode } from 'pages/Landings/utils';

export default makeStyles<{ smaller: boolean; blacken: boolean }>({ name: 'Title' })((theme, { smaller, blacken }) => {
    return {
        root: {
            marginTop: 0,
            marginBottom: 0,
            background: blacken
                ? '#232323'
                : isLightMode(theme)
                ? 'linear-gradient(249deg, #FA7342 7.18%, #BB2B6F 172.88%)'
                : 'linear-gradient(102deg, #FFF 37.9%, #FF7A38 92.44%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            width: 'fit-content'
        },
        h1: {
            fontSize: smaller ? 72 : 80,
            fontWeight: 700,
            lineHeight: smaller ? '88px' : '92px',
            letterSpacing: smaller ? '-1.8px' : '-2px',
            [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                fontSize: smaller ? 36 : 40,
                lineHeight: smaller ? '44px' : '48px',
                letterSpacing: smaller ? '-0.9px' : '-1px'
            }
        },
        h2: {
            fontSize: smaller ? 42 : 48,
            fontWeight: 600,
            lineHeight: smaller ? '50px' : '56px',
            letterSpacing: smaller ? '-1.1px' : '-1.2px',
            [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                fontSize: smaller ? 30 : 32,
                lineHeight: smaller ? '38px' : '40px',
                letterSpacing: smaller ? '-0.7px' : '-0.8px'
            }
        },
        _left: {
            textAlign: 'left',
            marginLeft: 0,
            marginRight: 'auto'
        },
        _center: {
            textAlign: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        _right: {
            textAlign: 'right',
            marginLeft: 'auto',
            marginRight: 0
        },
        _smaller: {}
    };
});
